import { LegalDocument } from '../types'

const privacyPolicy: LegalDocument = {
  title: 'Privacy Policy',
  version: '1.0.0',
  createdAt: '2025-08-22',
  url: 'https://www.hamiltonbilling.com/privacy',
  sections: [
    {
      title: 'Introduction',
      content: [
        {
          type: 'text',
          content:
            'Welcome to Hamilton Billing! We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services. By using our website, you agree to the terms of this Privacy Policy.',
        },
      ],
    },
    {
      title: 'Information We Collect',
      content: [
        {
          type: 'text',
          content:
            'We use Google Cloud services, including Firebase, for authentication, database, and storage. These services are configured to comply with the Health Insurance Portability and Accountability Act (HIPAA), ensuring the protection of your Protected Health Information (PHI). The information we collect includes:',
        },
        {
          type: 'list',
          items: [
            {
              type: 'text',
              title: 'Authentication Data',
              content:
                'We collect your email address, password, and other information you provide when you create an account and log in. This data is securely stored and managed by Firebase Authentication.',
            },
            {
              type: 'text',
              title: 'Firestore Data',
              content:
                'We store your personal health information, medical records, and other data you provide to us in a secure Firestore database.',
            },
            {
              type: 'text',
              title: 'Storage Data',
              content:
                'We store files, such as medical images and documents, that you upload to our website in a secure Firebase Storage bucket.',
            },
          ],
        },
      ],
    },
    {
      title: 'How We Use Your Information',
      content: [
        {
          type: 'text',
          content: 'We use your information to:',
        },
        {
          type: 'list',
          items: [
            {
              type: 'text',
              title: 'Provide our Services',
              content:
                'We use your data to provide you with the services you request, such as medical record management and communication with your healthcare provider.',
            },
            {
              type: 'text',
              title: 'Secure Your Data',
              content:
                'We use robust security measures, including those provided by Google Cloud, to protect your data from unauthorized access, use, or disclosure. All data is encrypted in transit and at rest.',
            },
            {
              type: 'text',
              title: 'Communicate with You',
              content:
                'We may use your email address to send you important updates and information about our services.',
            },
          ],
        },
      ],
    },
    {
      title: 'Data Security and Sharing',
      content: [
        {
          type: 'text',
          content:
            'We are committed to protecting your personal information. We do not sell, trade, or otherwise transfer your personal information to outside parties. Your personal data is only accessible to your designated healthcare provider and authorized Hamilton Billing employees who assist with the billing process. All data is viewed solely through our secure website interface and is not shared with any other parties, including advertisers.',
        },
        {
          type: 'text',
          content:
            'While we use Google Cloud Services to store and manage your data, we maintain a Business Associate Agreement (BAA) with Google to ensure the highest level of security and compliance for your Protected Health Information (PHI) under HIPAA regulations.',
        },
      ],
    },
    {
      title: 'Troubleshooting and Device Data',
      content: [
        {
          type: 'text',
          content:
            'In order to assist with troubleshooting and resolve technical issues, we may collect and use certain device data. This data is collected automatically and includes:',
        },
        {
          type: 'list',
          items: [
            {
              type: 'text',
              content: '`adblockDetected` (boolean)',
            },
            {
              type: 'text',
              content: '`browserName` (string, e.g., "Chrome")',
            },
            {
              type: 'text',
              content: '`fullVersion` (string, e.g., "114.0.0.0")',
            },
            {
              type: 'text',
              content: '`majorVersion` (number, e.g., 114)',
            },
            {
              type: 'text',
              content: '`reportedOn` (number, timestamp)',
            },
            {
              type: 'text',
              content: '`userAgent` (string, e.g., "Mozilla/5.0 (Macintosh...)")',
            },
          ],
        },
        {
          type: 'text',
          content:
            'This information is used solely for the purpose of diagnosing and fixing problems with our services and is not shared with any third parties.',
        },
      ],
    },
    {
      title: 'Your Rights',
      content: [
        {
          type: 'text',
          content: 'You have the right to:',
        },
        {
          type: 'list',
          items: [
            {
              type: 'text',
              title: 'Access Your Data',
              content: 'You can request a copy of the personal information we hold about you.',
            },
            {
              type: 'text',
              title: 'Correct Your Data',
              content:
                'You can request that we correct any inaccurate or incomplete personal information we hold about you.',
            },
            {
              type: 'text',
              title: 'Delete Your Data',
              content: 'You can request that we delete your personal information.',
            },
            {
              type: 'text',
              title: 'Object to Processing',
              content: 'You can object to the processing of your personal information.',
            },
          ],
        },
        {
          type: 'text',
          content:
            'To exercise any of these rights, please contact us at info@hamiltonbilling.com. We will respond to your request within 30 days.',
        },
      ],
    },
    {
      title: 'Changes to This Privacy Policy',
      content: [
        {
          type: 'text',
          content:
            'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.',
        },
      ],
    },
    {
      title: 'Contact Us',
      content: [
        {
          type: 'text',
          content:
            'If you have any questions about this Privacy Policy, please contact us at info@hamiltonbilling.com.',
        },
      ],
    },
  ],
}

export default privacyPolicy
